import { Distance } from "domain/entities/distance";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface DistancyState {
  distanceToDelete: Distance | null;
  setDistanceToDelete: (newParameter: Partial<Distance>) => void;
  resetDistanceToDelete: () => void;
}

const initialDistancyState: Distance = {
  id: "",
  locationOrigin: "",
  locationDestination: "",
  distanceKm: 0,
  type: "",
  createdAt: new Date(),
  modifiedAt: new Date(),
  lastModifiedBy: "",
};

export const useDistanceDeleteStore = create<DistancyState>()(
  devtools(
    (set) => ({
      distanceToDelete: initialDistancyState,
      setDistanceToDelete: (newParameter: Distance) =>
        set((state) => ({
          distanceToDelete: {
            ...state.distanceToDelete,
            ...newParameter,
          } as Distance,
        })),
      resetDistanceToDelete: () =>
        set({ distanceToDelete: initialDistancyState }),
    }),
    { name: "ParameterSelected" }
  )
);
